
    import { defineComponent } from 'vue'
    import Column from 'primevue/column'
    import DataTable from 'primevue/datatable'
    import Dialog from 'primevue/dialog'
    import { FilterOperator } from 'primevue/api'
    import { filterDefault } from '@/helpers/commons/filterHelper'
    import useModeDescriptor from './UseModesDescriptor.json'
    import LovsDetail from './DriversManagementLovsDetail.vue'
    export default defineComponent({
        name: 'lovs-dialog',
        components: {
            DataTable,
            Column,
            Dialog,
            LovsDetail
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            lovs: {
                type: Array,
                required: false
            },
            selectedLovProp: {
                type: Array,
                required: false
            }
        },
        emits: ['close', 'apply'],
        data() {
            return {
                selectedLov: {} as any,
                detailVisiable: false,
                lovDetails: {} as any,
                useModeDescriptor,
                filters: {
                    global: [filterDefault],
                    label: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    },
                    name: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    },
                    description: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    }
                } as Object
            }
        },
        mounted() {
            this.selectedLov = { ...this.selectedLovProp }
        },
        watch: {
            selectedLovProp() {
                this.selectedLov = { ...this.selectedLovProp }
            }
        },
        methods: {
            applyLov() {
                this.$emit('apply', this.selectedLov)
                this.detailVisiable = false
            },
            closeLovDialog() {
                this.$emit('close')
                this.detailVisiable = false
            },
            lovDetail(lov: any) {
                this.detailVisiable = true
                this.lovDetails = lov
            }
        }
    })
